import { useAppSelector } from 'shared/hooks/redux/hooks';
import { select_billed_sim_card, useGetSimInDevice } from 'console/sim/utils/select-sim';
import { isAutoPaymentEnabled } from 'console/billing/billing-utils';
import { useMemo } from 'react';
import { billedSimState } from 'console/sim/utils/state';
export function useBilledSimState(sim_id, operator) {
    const billed_sim = useAppSelector((state) => select_billed_sim_card(state, sim_id == null || operator == null
        ? null
        : { id: sim_id, operator }));
    const auto_payment = useAppSelector(isAutoPaymentEnabled);
    const { state, prices } = useAppSelector((state) => state.billing);
    const sim_prices = useMemo(() => new Map((prices?.sim_tariffs ?? []).map(({ id, month_price_x100 }) => [
        id,
        month_price_x100,
    ])), [prices]);
    if (!billed_sim) {
        return [null, null];
    }
    return [
        billed_sim,
        billedSimState(billed_sim, auto_payment, state.data.balance_x100, sim_prices.get(billed_sim.tariff_state.current)),
    ];
}
export function useGetSimStatus(device_id) {
    const [billed_sim, foreign_sim] = useGetSimInDevice(device_id);
    const [, billed_sim_state] = useBilledSimState(billed_sim?.sim_card.id.id, billed_sim?.sim_card.id.operator);
    return ENABLE_SIM //&&
        ? // Device.has_capability(device?.capabilities ?? [], Capability.has_sim_in_device)
            {
                warning: billed_sim_state != null ? billed_sim_state.status != 'ok' : false,
                billed_sim,
                foreign_sim,
                billed_sim_state,
            }
        : {
            warning: false,
            billed_sim: null,
            foreign_sim: null,
            billed_sim_state: null,
        };
}
